import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LassoToolIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 2 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M4 12c0-4 5-8 10-8s6 3 6 6-3 6-8 6-8-2-8-4z"
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
      />
      <circle cx="8" cy="19" r="2" stroke={color} strokeWidth={strokeWidth} fill="none" />
    </BaseIcon>
  ),
);

LassoToolIcon.displayName = 'LassoToolIcon';
